import ApiClient from '@/api-client';

export default {
    namespaced: true,
    state: {
        disableOverFlowForComponents: [],
        modalOpen: false,
        sideBarOpen: false,
        collapsedSideBar: false,
        scroll: {},
        features: {
            invoicing: false,
        },
        activeTables: [],
        modalContextStack: [], // Array of { modalId, context }
    },
    getters: {
        disableOverFlow(state) {
            return state.disableOverFlowForComponents.length !== 0;
        },
        modalContext(state) {
            // Return the topmost modal context (top of stack)
            return state.modalContextStack.length > 0
                ? state.modalContextStack[state.modalContextStack.length - 1].context
                : null;
        },
    },
    mutations: {
        addComponentToOverFlow(state, componentName) {
            state.disableOverFlowForComponents.push(componentName);
        },
        removeComponentFromOverFlow(state, componentName) {
            state.disableOverFlowForComponents = state.disableOverFlowForComponents.filter((name) => name !== componentName);
        },
        isModalOpen(state, value) {
            state.modalOpen = value;
        },
        isSideBarOpen(state, value) {
            state.sideBarOpen = value;
        },
        setCollapsedSideBar(state, value) {
            state.collapsedSideBar = value;
        },
        scrollTo(state, value) {
            state.scroll = value;
        },
        setMostRecent(state, { componentName, value }) {
            const activeTables = state.activeTables.filter((activeTable) => activeTable.componentName !== componentName);
            state.activeTables = activeTables;
            state.activeTables.push({ componentName, value });
        },
        setFeature(state, feature) {
            state.features = { ...state.features, ...feature };
        },
        pushModalContext(state, { modalId, context }) {
            if (context && modalId) {
                state.modalContextStack.push({ modalId, context });
            }
        },
        removeModalContext(state, modalId) {
            // Remove context for this specific modal, not just pop the last item
            state.modalContextStack = state.modalContextStack.filter(entry => entry.modalId !== modalId);
        },
    },
    actions: {
        disableOverFlowForComponent({ commit }, componentName) {
            commit('addComponentToOverFlow', componentName);
        },
        enableOverFlowForComponent({ commit }, componentName) {
            commit('removeComponentFromOverFlow', componentName);
        },
        setModalStatus({ commit }, status) {
            commit('isModalOpen', status);
        },
        setSideBarStatus({ commit }, status) {
            commit('isSideBarOpen', status);
        },
        collapseSideBar({ commit, state }) {
            commit('setCollapsedSideBar', !state.collapsedSideBar);
        },
        async checkFeature({ commit }, feature) {
            const response = await ApiClient.get(`/api/features/${feature}`);
            commit('setFeature', { [feature]: response.data.enabled });
        },
        setModalContext({ commit }, payload) {
            if (payload && payload.modalId && payload.context) {
                // Add context
                commit('pushModalContext', payload);
            } else if (payload && payload.modalId) {
                // Remove context by modal ID
                commit('removeModalContext', payload.modalId);
            }
        },
    },
};
